import React, { Component } from 'react';
//import { Link } from 'react-router-dom';
import './alimComponent.css';
import { Spinner } from 'react-bootstrap';
import AutenticationService from '../services/authservice.js';
import LuceSrv from '../services/Api/Alim/Alim.js';

export default class CaldaiaComponent extends Component {
  state = {
    loading: false,
    loadingclose: false,
    msgremote: 'messaggio di ritorno',
    msgremoteopen: 'messaggio di ritorno open',
  };

  componentDidMount(props) {
    console.log('componentDidMount padre :', this.props);
    this.setState({
      history: this.props.history,
    });
debugger;
    this.getOpenCloseCancello("");
   
  }

  handleError = (error, id) => {
    console.log(error);
    let mes = '';
    try {
      if (error.response.data) {
        mes = error.response.data.msgc;
      } else {
        mes = error;
      }
    } catch (e) {
      mes = error;
    }
    this.setMesRemo(mes, id);
    
    if (error.response.data.status === 403) {
      setTimeout(() => {
        if (this.state.history) this.state.history.push('/login/login');
      }, 3000);
    }
  };
  handleResponse = (response, id) => {
    debugger;
    console.log(
      'OUTPUT: CancelloComponent -> handleResponse -> response',
      response
    );
    this.setMesRemo(response.data.msgc, id);
  
  };
  setMesRemo = (mes, id) => {
    switch (id) {
      case 'open':
        this.setState({ msgremoteopen: mes, msgremote: mes });
        break;
      case 'close':
        this.setState({ msgremote: mes, msgremoteopen: mes });
        break;
      case 'onoff':
          this.setState({ msgremote: mes, msgremoteopen: mes });
          break;  
     
      default:
        console.log('case non definito');
        break;
    }
    this.setState({ loading: false });
    this.setState({ loadingclose: false });
  };
  render() {
    return (
      <div className='py-5 CancelloComponent'>
        <div className='container-fluid'>
          <section className='py-2'>
            <h3 className='mb-2 text-center'>
              <b>Controllo Luce</b>
            </h3>
          </section>
          <div className='row'>
            <div className='col-sm-1'></div>
            <div className='col-sm-10 '>
              <button
                className='mt-2 btn btn-primary mybut'
                //href='#'
                onClick={this.OnLuce}
              >
                <div className='text-left lead'>
                  <i className='p-2 fas fa-snowflake '>
                    {this.state.loading && (
                      <Spinner animation='border' role='status'></Spinner>
                    )}
                  </i>
                </div>

                <h2>
                  <b>Premi per Accendere</b>
                </h2>
                <div className='text-left lead'><h3>{this.state.msgremoteopen}</h3></div>
              </button>
            </div>
            <div className='col-sm-1'></div>
          </div>

          <div className='py-4 row'>
            <div className='col-sm-1'></div>
            <div className='col-sm-10'>
              <button
                className='mt-2 btn btn-success mybut'
                //href='#'
                onClick={this.OffLuce}
              >
                <div className='text-left lead'>
                  <i className='p-2 fas fa-snowflake '>
                    {this.state.loadingclose && (
                      <Spinner animation='border' role='status'></Spinner>
                    )}
                  </i>
                </div>

                <h2>
                  <b>Premi per Spegnere</b>
                </h2>
                <div className='text-left lead'><h3>{this.state.msgremote}</h3></div>
              </button>
            </div>
            <div className='col-sm-1'></div>
          </div>
        </div>
      </div>
    );
  }
  getOpenCloseCancello = (event) => {
    debugger;
    console.log(
      'OUTPUT: CancelloComponent -> luce -> ',
      //event.target.innerText
    );
    this.setState({ loading: true });
    this.setState({ loadingclose: false });
    const idute = AutenticationService.getIdUte();
    const data = { id: 1, method: 'onoff', timer: 0, idute: idute, onoff :'1' };
    this.setState({ msgremoteopen: 'Avvio Richiesta Servizio Luce' });

    LuceSrv.getOpenLuceBasic(data)
      .then((response) => this.handleResponse(response, 'onoff'))
      .catch((error) => this.handleError(error, 'onoff'));
    
  };
  OnLuce = (event) => {
    console.log(
      'OUTPUT: CancelloComponent -> OnLuce -> ',
      event.target.innerText
    );
    this.setState({ loading: true });
    this.setState({ loadingclose: false });
    const idute = AutenticationService.getIdUte();
    const data = { id: 1, method: 'onluce', timer: 0, idute: idute, onoff :'1' };
    this.setState({ msgremoteopen: 'Avvio Richiesta Accensione Luce' });

    LuceSrv.getOpenLuceBasic(data)
      .then((response) => this.handleResponse(response, 'open'))
      .catch((error) => this.handleError(error, 'open'));
    
  };
  OffLuce = (event) => {
    console.log(
      'OUTPUT: CancelloComponent -> CloseCancello -> ',
      event.target.innerText
    );
    this.setState({ msgremote: 'Avvio Richiesta Spegni luce' });
    const idute = AutenticationService.getIdUte();
    const data = { id: 0, method: 'offluce', timer: 0, idute: idute, onoff :'0' };
    LuceSrv.getOpenLuceBasic(data)
      .then((response) => this.handleResponse(response, 'close'))
      .catch((error) => this.handleError(error, 'close'));
    this.setState({ loading: false });
    this.setState({ loadingclose: true });
  };
}

